import { useState } from "react";
import { faqs } from "@/mocks/chigua";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="honeycomb py-14 md:py-20">
      <div className="mx-auto grid max-w-6xl gap-8 px-4 md:px-6 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <p className="mb-2 text-xs font-medium tracking-widest text-secondary-600">FAQ</p>
          <h2 className="font-display text-3xl text-foreground-950 md:text-4xl">
            吃瓜群众<span className="text-secondary-500">常问</span>
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            关于吃瓜52怎么打卡、怎么蹲后续、信息靠不靠谱，答案都在这里。还有疑问欢迎到评论区找管理员聊聊。
          </p>
          <a
            href="#subscribe"
            className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
          >
            还有其他问题？<i className="ri-question-answer-line"></i>
          </a>
        </div>

        <div className="flex flex-col gap-3 lg:col-span-3">
          {faqs.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={i}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  isOpen ? "border-secondary-300 bg-background-50" : "border-background-200 bg-background-50/60"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                      <i className="ri-question-line text-sm"></i>
                    </span>
                    <span className="text-sm font-medium text-foreground-900 md:text-base">{f.q}</span>
                  </span>
                  <i
                    className={`shrink-0 text-lg text-secondary-600 transition-transform ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pl-16">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}